import { Select } from 'antd'
import React from 'react'
const const_ulds = {
  764: ['PMC', 'PAG', 'PAJ', 'RAP', 'PLA', 'PLB', 'FLA'],
  763: ['PMC', 'PAG', 'PAJ', 'RAP', 'PLA', 'PLB', 'FLA'],
  332: ['PMC', 'PAG', 'PAJ', 'RAP'],
  333: ['PMC', 'PAG', 'PAJ', 'RAP'],
  339: ['PMC', 'PAG', 'PAJ', 'RAP'],
  359: ['PMC', 'PAG', 'PAJ', 'RAP'],
}

const bin_ulds = {
  '764': ['LD2', 'LD3', 'RKN', 'LD4', 'LD8'],
  '763': ['LD2', 'LD3', 'RKN', 'LD4', 'LD8'],
  '332': ['LD3', 'RKN', 'PLA', 'PLB', 'FLA'],
  '333': ['LD3', 'RKN', 'PLA', 'PLB', 'FLA'],
  '339': ['LD3', 'RKN', 'PLA', 'PLB', 'FLA'],
  '359': ['LD3', 'RKN', 'PLA', 'PLB', 'FLA'],
  '332true': ['LD3', 'RKN'],
  '333true': ['LD3', 'RKN'],
  '339true': ['LD3', 'RKN'],
  '359true': ['LD3', 'RKN'],
}

const uldDropdown = (props) => {

  return <Select
    className='wnb-uld-select'
    value={props.value}
    onChange={props.onChange}
    onBlur={props.onSubmit}
    style={{
      width: '100%',
      margin: 'auto'
    }}
    size='small'
    disabled={props.disabled}
  >
    <Select.Option disabled value=''>Select ULD</Select.Option>
    {props.name?.includes('P') ? const_ulds[props.ac_type]?.map(uld => (
      <Select.Option key={uld} value={uld}>{uld}</Select.Option>
    )) : bin_ulds[props.onePair ? props.ac_type + props.onePair : props.ac_type]?.map(uld => (
      <Select.Option key={uld} value={uld}>{uld}</Select.Option>
    ))}
    {props.fqa && <Select.Option key='FQA' value='FQA'>FQA</Select.Option>}
  </Select>
}

export default uldDropdown